// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4142 1H3V23H21V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5ZM16 12.5H14V16.5C14 17.8807 12.8807 19 11.5 19C10.1193 19 9 17.8807 9 16.5C9 15.1193 10.1193 14 11.5 14C11.6712 14 11.8384 14.0172 12 14.05V10.5H16V12.5Z"}}]};

const FileMusicFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-music-filled',
    ref,
    icon: element,
  },
));

FileMusicFilledIcon.displayName = 'FileMusicFilledIcon';

export default FileMusicFilledIcon;
